export default "__VITE_ASSET__oQ1GHS2R__"